import { Divider, List, ListItemButton, ListItemText } from "@mui/material";
import { Fragment } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { settingsOptions } from "../../config/settingsOptions";

export default function SettingsOptionsList() {
    const options = settingsOptions;
    const BASE_URL = "/admin/settings/";
    const { t } = useTranslation("settings");

    return (
        <List>
            {options.map((option, index) => (
                <Fragment key={option.id}>
                    <ListItemButton component={Link} to={`${BASE_URL}${option.path}`} sx={{ paddingLeft: 0 }}>
                        <ListItemText
                            primary={t(`settingsOptionsList.${option.translationKey}.name`)}
                            secondary={t(`settingsOptionsList.${option.translationKey}.description`)}
                            sx={{ paddingLeft: 2 }}
                        />
                    </ListItemButton>
                    {options.length !== index + 1 && <Divider />}
                </Fragment>
            ))}
        </List>
    );
}
